import { getDefaultState } from './state'

export const mutations = {
    resetPortalState (state) {
        Object.assign(state, getDefaultState())
    },
    mutatePortalLoad (state, payload) {
        state.loading = payload
    },
    mutateHeader (state, payload) {
        state.header = payload
    },
    mutateFooter (state, payload) {
        state.footer = payload
    },
    mutateCommonDropdown (state, payload) {
        state.commonObj = Object.assign(state.commonObj, payload)
    },
    localizeCommonDropdown (state, payload) {
        state.commonObj.assistiveDeviceList = state.commonObj.assistiveDeviceList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.ccList = state.commonObj.ccList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.hpcList = state.commonObj.hpcList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.rxList = state.commonObj.rxList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.dhList = state.commonObj.dhList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.oeList = state.commonObj.oeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.pmhList = state.commonObj.pmhList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.adviceList = state.commonObj.adviceList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.diagnosisList = state.commonObj.diagnosisList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.therapyCenterList = state.commonObj.therapyCenterList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.disabilityTypeList = state.commonObj.disabilityTypeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.divisionList = state.commonObj.divisionList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.districtList = state.commonObj.districtList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.upazilaList = state.commonObj.upazilaList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.unionList = state.commonObj.unionList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.cityCorporationList = state.commonObj.cityCorporationList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.pauroshobaList = state.commonObj.pauroshobaList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.wardList = state.commonObj.wardList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.fiscalYearList = state.commonObj.fiscalYearList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.officeTypeList = state.commonObj.officeTypeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.officeList = state.commonObj.officeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.designationList = state.commonObj.designationList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
    },
    mutateServiceData (state, payload) {
        state.serviceData = payload
        state.orgList = payload.orgList
        state.customerTypeList = payload.serviceCustomerTypeList
        state.categoryList = payload.serviceCategoryList
    },
    mutateCustomerTypeList (state, payload) {
        state.customerTypeList = payload
    },
    mutateServiceList (state, payload) {
        state.serviceList = payload
    },
    mutateSearch (state, payload) {
        state.searchData.loading = !state.searchData.loading
        state.searchData = Object.assign(state.searchData, payload)
    },
    mutateOrgList (state, payload) {
        state.orgList = payload
    },
    mutateCategoryList (state, payload) {
        state.categoryList = payload
    },
    mutateFaqList (state, payload) {
        state.faqList = payload
    },
    mutateNoticeList (state, payload) {
        state.noticeList = payload
    },
    mutateNewsList (state, payload) {
        state.newsList = payload
    },
    setServiceUrl (state, payload) {
        state.serviceUrl = Object.assign(state.serviceUrl, payload)
    }
}
